<template>
  <div v-on="$listeners">
    <the-icon ref="theicon"
              :style="{width: `${size}px`,height: `${size}px`}"
    ></the-icon>
  </div>
</template>

<script>
import TheIcon from "@/assets/icons/play.svg";

export default {
  name: "APlayIcon",
  components: {
    TheIcon
  },
  props: {
    size: {
      type: Number,
      default: 45
    }
  }
}
</script>

<style scoped lang="scss">
.icon {
  stroke-width: 0.6;
}
</style>